import { QUERY_KEYS } from "@/libraries/constant";
import type { CreateChannelBodyPayloadSchema } from "@/schemas";
import type { PostCreateChannelResponse, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

const useChannel = () => {
	const mutateCreateChannel = useMutation<
		PostCreateChannelResponse,
		ResError,
		CreateChannelBodyPayloadSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_CREATE_CHANNEL],
	});

	return {
		mutateCreateChannel,
	};
};

export default useChannel;
